import React from 'react';

const Validate = (props) => {
  return (
    <div>
      <span className='text-red-400 text-sm font-[600] h-auto'>
        {props.message}
      </span>
    </div>
  );
};

export default Validate;
